import { I2cAlert } from "@webcomponents/i2cwebcomponents/dist/react";

const AlertMessage = ({
  variant = "danger",
  message,
  open,
  type = "plain",
  headerArt = "cs-linear-alert-circle",
  layout = "layoutAsideLeft",
  closeAble = true,
  headerArtStyle = "default",
  children = null,
  duration = 5000,
}) => (
  <I2cAlert
    open={open}
    className="alert"
    variant={variant}
    type={type}
    layout={layout}
    headerArt={headerArt}
    headerArtStyle={headerArtStyle}
    closable={closeAble}
    duration={duration}
  >
    {children ??
      (message && (
        <span slot="label" style={{ fontSize: "var(--i2c-font-size-text-sm)" }}>
          {message}
        </span>
      ))}
  </I2cAlert>
);

export default AlertMessage;
